import React, { useEffect, useRef, useState } from "react";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { CirclePlus } from "lucide-react";
import UsersIcon from "assets/SidebarIcons/UsersIcon";
import CheckSquareIcon from "assets/SidebarIcons/CheckSquareIcon";
import FileIcon from "assets/SidebarIcons/FileIcon";
import WalletIcon from "assets/SidebarIcons/WalletIcon";
import CreditCardIcon from "assets/SidebarIcons/CreditCardIcon";
import ClockIcon from "assets/SidebarIcons/ClockIcon";
import Show from "Components/Show/Show";
import NewPatientPopup from "Popups/NewPatientPopup/NewPatientPopup";
import EligibiltyPopup from "Popups/EligibiltyPopup/EligibiltyPopup";
import { useDispatch, useSelector } from "react-redux";
import CreateNewClaimPopup from "Popups/CreateNewClaimPopup/CreateNewClaimPopup";
import { swtichTab } from "Redux/TabsSlice/TabsSlice";
import { toggleClaimPopup } from "Redux/PopupSlice/PopupSlice";
import AddPaymentPopup from "Popups/AddPaymentPopup/AddPaymentPopup";
import AddNewPatientPaymentPopup from "Popups/AddNewPatientPaymentPopup/AddNewPatientPaymentPopup";
import CreateTaskPopup from "MainTabs/Tasks/Taskpopups/CreateTaskPopup";
import { Tooltip } from "react-tooltip";
const quickActionItems = [
    { id: "addPatient", label: "Add Patient", shortcut: "A + P", icon: UsersIcon },
    { id: "addEligibility", label: "Add Eligibility", shortcut: "A + E", icon: CheckSquareIcon },
    { id: "addClaim", label: "Add Claim", shortcut: "A + C", icon: FileIcon },
    { id: "addPatientPayment", label: "Add Patient Payment", shortcut: "A + Y", icon: WalletIcon },
    { id: "addInsurancePayment", label: "Add Insurance Payment", shortcut: "A + I", icon: CreditCardIcon },
    { id: "addTask", label: "Add Task", shortcut: "A + T", icon: ClockIcon },
];

const QuickActions = () => {
    const [newPatientPopup, setNewPatientPopup] = useState(false);
    const [eligibilyPopup, setEligibilyPopup] = useState(false);
    const [patientPaymentPopup, setPatientPaymentPopup] = useState(false);
    const [insurancePaymentPopup, setInsurancePaymentPopup] = useState(false);
    const [taskPopup, setTaskPopup] = useState(false);

    const { claimPopup } = useSelector((state) => state.popup);
    const dispatch = useDispatch();
    // ******** Eligibility Popup Functions ********
    const openEligibilyPopup = () => {
        setEligibilyPopup(true);
    };
    const closeEligibilyPopup = () => {
        setEligibilyPopup(false);
    };
    // ******** New Patient Popup Functions ********

    const openNewPatientPopup = () => {
        setNewPatientPopup(true);
    };
    const closeNewPatientPopup = () => {
        setNewPatientPopup(false);
    };
    // ******** Claim Popup Functions ********
    const openClaimPopup = () => {
        dispatch(toggleClaimPopup(true));
    }
    const handleAddNewClaim = (patient) => {
        dispatch(
            swtichTab({ parentName: "charges", subTabName: "claim", subTabData: { patientId: patient.id } })
        );
        dispatch(toggleClaimPopup(false))
    }

    // ******** Patient Payment Popup Functions ********
    const openPatientPaymentPopup = () => {
        setPatientPaymentPopup(true);
    }
    const closePatientPaymentPopup = () => {
        setPatientPaymentPopup(false);
    }

    // ******** Insurance Payment Popup Functions ********
    const openInsurancePaymentPopup = () => {
        setInsurancePaymentPopup(true);
    }
    const closeInsurancePaymentPopup = () => {
        setInsurancePaymentPopup(false);
    }

    // ******** Task Popup Functions ********
    const openTaskPopup = () => {
        setTaskPopup(true);
    }
    const closeTaskPopup = () => {
        setTaskPopup(false);
    }

    const pressedKeysRef = useRef(new Set());

    useEffect(() => {
        const hotkeyActionMap = {
            p: () => setNewPatientPopup(true),
            e: () => setEligibilyPopup(true),
            c: () => dispatch(toggleClaimPopup(true)),
            y: () => setPatientPaymentPopup(true),
            i: () => setInsurancePaymentPopup(true),
            t: () => setTaskPopup(true),
        };

        const isTypingElement = (element) => {
            if (!element) return false;

            const tagName = element.tagName?.toLowerCase();
            return tagName === "input" || tagName === "textarea" || element.isContentEditable;
        };

        const handleKeyDown = (event) => {
            if (isTypingElement(event.target)) {
                pressedKeysRef.current.clear();
                return;
            }

            if (event.repeat) return;

            const key = event.key.toLowerCase();
            pressedKeysRef.current.add(key);

            const action = hotkeyActionMap[key];
            if (action && pressedKeysRef.current.has("a")) {
                event.preventDefault();
                action();
            }
        };

        const handleKeyUp = (event) => {
            pressedKeysRef.current.delete(event.key.toLowerCase());
        };

        const clearPressedKeys = () => {
            pressedKeysRef.current.clear();
        };

        window.addEventListener("keydown", handleKeyDown);
        window.addEventListener("keyup", handleKeyUp);
        window.addEventListener("blur", clearPressedKeys);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
            window.removeEventListener("keyup", handleKeyUp);
            window.removeEventListener("blur", clearPressedKeys);
        };
    }, [dispatch]);

    const handleQuickAction = (id) => {
        if (id === "addPatient") {
            openNewPatientPopup();
        }
        if (id === "addEligibility") {
            openEligibilyPopup();
        }
        if (id === "addClaim") {
            openClaimPopup();
        }
        if (id === "addPatientPayment") {
            openPatientPaymentPopup();
        }
        if (id === "addInsurancePayment") {
            openInsurancePaymentPopup();
        }
        if (id === "addTask") {
            openTaskPopup();
        }
    };
    const isAnyQuickActionPopupOpen = newPatientPopup || eligibilyPopup || claimPopup || patientPaymentPopup || insurancePaymentPopup || taskPopup;

    return (
        <>
            <Show when={newPatientPopup}>
                <NewPatientPopup onClose={closeNewPatientPopup} />
            </Show>
            <Show when={eligibilyPopup}>
                <EligibiltyPopup onClose={closeEligibilyPopup} patientId={0} patientName="" />
            </Show>
            <Show when={claimPopup}>
                <CreateNewClaimPopup handleAddNew={handleAddNewClaim} onClose={() => dispatch(toggleClaimPopup(false))} />
            </Show>
            <Show when={patientPaymentPopup}>
                <AddNewPatientPaymentPopup onClose={closePatientPaymentPopup} />
            </Show>

            <Show when={insurancePaymentPopup}>
                <AddPaymentPopup onClose={closeInsurancePaymentPopup} />
            </Show>
            <Show when={taskPopup}>
                <CreateTaskPopup onClose={closeTaskPopup} patientInfo={null} claimInfo={null} />
            </Show>
            <Tooltip id="quick-actions" hidden={isAnyQuickActionPopupOpen} />

            <DropdownMenu.Root>
                <DropdownMenu.Trigger
                    data-tooltip-id="quick-actions"
                    data-tooltip-content="Create"
                    data-tooltip-place="bottom"
                    aria-label="Open quick actions"
                    className="inline-flex items-center justify-center w-8 h-8 text-white transition rounded-full outline-none "
                >
                    <CirclePlus className="rounded-full bg-primary" size={22} />
                </DropdownMenu.Trigger>

                <DropdownMenu.Portal>
                    <DropdownMenu.Content
                        align="end"
                        sideOffset={10}
                        className="z-50 min-w-[250px] rounded-xl border border-gray-100 bg-white p-1.5 shadow-lg"
                    >
                        {quickActionItems.map((item) => {
                            const ItemIcon = item.icon;
                            return (
                                <DropdownMenu.Item

                                    key={item.id}
                                    onClick={() => handleQuickAction(item.id)}
                                    data-tooltip-content={item.shortcut}
                                    data-tooltip-place="left"
                                    className="flex cursor-pointer select-none items-center justify-between rounded-md px-3 py-2 text-sm text-[#3f4754] outline-none transition hover:bg-gray-50 focus:bg-gray-50"
                                >
                                    <span className="flex items-center gap-2.5">
                                        <span className="flex items-center justify-center size-4">
                                            <ItemIcon size={12} className="text-[#97a0af] size-1" />
                                        </span>
                                        {item.label}
                                    </span>
                                    <div className="flex items-center gap-1">
                                        {item.shortcut.split('+').map((key, index) => (
                                            <span key={index} className="px-2 py-1 text-xs  lowercase bg-[#F8FAFB] rounded-sm">
                                                {key}
                                            </span>
                                        ))}
                                    </div>
                                </DropdownMenu.Item>
                            );
                        })}
                    </DropdownMenu.Content>
                </DropdownMenu.Portal>
            </DropdownMenu.Root>
        </>

    );
};

export default QuickActions;